export const PRIMARY = '#4781FF'
export const SECONDARY = '#08285B'
export const THIRD = '#35CBCC'
export const FOURTH = '#1155C1'
export const YELMO_GREEN = '#4FC974'
export const YELMO_TURQ = '#35CBCC'
export const YELMO_CLEAR_GRAY = '#F0F0F1'
export const YELMO_PURPLE = '#8234CF'

export const SUCCESS = '#377E22'
export const INFO = '#3FD0FC'
export const WARNING = '#FFBE06'
export const DANGER = '#F64E4E'
export const DEFAULT = '#6C757D'

export const GRAY = '#7F7F7F'
export const SHADOW_GRAY = '#DDDDDD'
export const DARK_GRAY = '#787878'
export const LIGHT_GRAY = 'rgba(255, 255, 255, 0.4)'
export const GRAY_MODAL = 'rgba(0, 0, 0, 0.6)'
export const BLACK = '#000000'
export const WHITE = '#FFFFFF'
export const PLACEHOLDER = '#F3F3F3'

export const BACKGROUND_SCREEN = '#F7F7F7'

const Colors = {
  primary: PRIMARY,
  secondary: SECONDARY,
  third: THIRD,
  fourth: FOURTH,
  yelmoGreen: YELMO_GREEN,
  yelmoTurq: YELMO_TURQ,
  yelmoClearGray: YELMO_CLEAR_GRAY,
  yelmoPurple: YELMO_PURPLE,
  success: SUCCESS,
  danger: DANGER,
  warning: WARNING,
  info: INFO,
  default: DEFAULT,
  gray: GRAY,
  shadowGray: SHADOW_GRAY,
  darkGray: DARK_GRAY,
  lightGray: LIGHT_GRAY,
  lightModal: GRAY_MODAL,
  black: BLACK,
  white: WHITE,
  placeholder: PLACEHOLDER,
  backgroundScreen: BACKGROUND_SCREEN,
}

export default Colors
